import React from "react";
import ApproveMotorbikeStatus from "./approveMotorbikeStatus";
import MotorbikeStatusPopups from "./motorbikeStatusPopups";
import RestrictedMotorbikePopup from "./RestrictedMotorbikePopup";

function MotorbikeLatestStatus({
  vehicle,
  props,
  handleReloadSingle,
  isCar = false,
}) {
  const handleStatus = () => {
    switch (
      isCar ? vehicle.car_latest_status : vehicle.motorbike_latest_status
    ) {
      case "Approved":
        if (vehicle.is_rego_date_still_valid) {
          if (vehicle.is_insurance_policy_date_still_valid) {
            return (
              <div className="value motorbike-status">
                <span className="approved-valid">Approved</span>
              </div>
            );
          } else {
            return (
              <div className="value motorbike-status">
                <span className="approved-invalid-expired">
                  Insurance Policy Expired
                </span>
              </div>
            );
          }
        } else {
          return (
            <div className="value motorbike-status">
              <span className="approved-invalid-expired">
                Registration Expired
              </span>
            </div>
          );
        }
      case "Processing":
        return (
          <div className="value motorbike-status">
            <span className="processing">Processing</span>
          </div>
        );
      case "Further Investigation":
        return (
          <div className="value motorbike-status">
            <span className="further-investigation">Further Investigation</span>
          </div>
        );
      case "Restricted":
        return (
          <div className="value motorbike-status">
            <span className="restricted">Restricted</span>
          </div>
        );
      case "Rejected":
        return (
          <div className="value motorbike-status">
            <span className="rejected">Rejected</span>
          </div>
        );
      case "Policy Expired":
        return (
          <div className="value motorbike-status">
            <span className="expired">Policy Expired</span>
          </div>
        );
      case "Rego Expired":
        return (
          <div className="value motorbike-status">
            <span className="expired">Rego Expired</span>
          </div>
        );

      case "Removed":
        return (
          <div className="value motorbike-status">
            <span className="removed">Removed</span>
          </div>
        );
      default:
        break;
    }
  };

  const handleMotorbikeStatusActions = () => {
    switch (
      isCar ? vehicle.car_latest_status : vehicle.motorbike_latest_status
    ) {
      case "Restricted":
        return (
          <RestrictedMotorbikePopup
            vehicle={vehicle}
            props={props}
            isCar={isCar}
            handleReloadSingle={handleReloadSingle}
          />
        );
      case "Approved":
        return (
          <ApproveMotorbikeStatus
            vehicle={vehicle}
            props={props}
            handleReloadSingle={handleReloadSingle}
            isCar={isCar}
          />
        );
      case "Processing":
        if (vehicle.is_allow_show_edit_button_result) {
          return (
            <MotorbikeStatusPopups
              vehicle={vehicle}
              isCar={isCar}
              props={props}
              handleReloadSingle={handleReloadSingle}
            />
          );
        } else {
          return null;
        }
      default:
        break;
    }
  };

  return (
    <div className="admin-info-components">
      <div className="row">
        <div className="col-md-4">
          <h5 className="admin-header-info">
            {isCar ? "Car Latest Status" : "Motorbike Latest Status"}
          </h5>
        </div>
        <div className="col-md-4">{handleStatus()}</div>
        <div className="col-md-4">{handleMotorbikeStatusActions()}</div>
      </div>
    </div>
  );
}

export default MotorbikeLatestStatus;
